var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 88 116",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.28882e-05 35.2377C-2.28882e-05 9.38667 19.4754 0.000320435 43.4996 0.000320435C67.5238 0.000320435 86.9993 9.38667 86.9993 35.2377C86.9993 61.0887 67.5238 115.7 43.4996 115.7C19.4754 115.7 -2.28882e-05 61.0887 -2.28882e-05 35.2377Z",
    fill: "#FFD346"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7503 79.9911C31.7503 72.2358 37.5929 69.4199 44.8002 69.4199C52.0075 69.4199 57.8501 72.2358 57.8501 79.9911C57.8501 87.7464 52.0075 104.13 44.8002 104.13C37.5929 104.13 31.7503 87.7464 31.7503 79.9911Z",
    fill: "#F18A0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpice);
export default __webpack_public_path__ + "static/media/SPICE.8e40201443c56433780c111084f11b9e.svg";
export { ForwardRef as ReactComponent };